import { EmptyCartIcon } from "@/assets/icons";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useShoppingCart } from "use-shopping-cart";

const EmptyCart = () => {
  const { handleCartClick } = useShoppingCart();
  const t = useTranslations("Cart");

  return (
    <div className="text-center py-10">
      <div className="mx-auto pb-7.5">
        <EmptyCartIcon className="mx-auto" />
      </div>

      <p className="pb-6">{t("continueShopping")}</p>

      <Link
        onClick={() => {
          handleCartClick();
        }}
        href="/"
        className="w-full lg:w-10/12 mx-auto flex justify-center font-medium text-white bg-dark py-[13px] px-6 rounded-full ease-out duration-200 hover:bg-opacity-95"
      >
        {t("continueShopping")}
      </Link>
    </div>
  );
};

export default EmptyCart;
